import axios from 'axios'
import { useCallback, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { setErrorState } from 'redux/features/general/generalSlice'
//import { toast } from 'react-toastify';

export const useRequest = () => {
	const navigate = useNavigate()
	const [loading, setLoading] = useState(false)
	const [error, setError] = useState()
	const token = JSON.parse(localStorage.getItem('auth'))?.token
	const dispatch = useDispatch()
	axios.interceptors.response.use(
		(response) => {
			return response
		},
		(err) => {
			setError(err)
			if (err.response?.status === 401) {
				dispatch(setErrorState({ status: err.response?.status, message: err.response.data?.value?.errors }))
				navigate('/unauthorized')
			}
			if (err.response?.status === 404) {
				//navigate('/blabal')
			}
			if (err.response?.status === 500) {
				navigate('/blabal')
			}
		}
	)
	const apiUrl = process.env.REACT_APP_API_ENDPOINT


	axios.defaults.baseURL = apiUrl

	const request = useCallback(async (url, options = {}) => {
		setLoading(true)
		options.headers = {
			Authorization: `Bearer ${token}`,
			'Content-Type': 'application/json',
			...options.headers,
		}
		options.data = options.data ? options.data : { ...options.body }
		const response = await axios(url, options).finally(() => setLoading(false))
		return response
	}, [])
	return [request, loading, error]
}
